import React, { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: React.ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class VimeoErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('VimeoErrorBoundary caught an error:', error, errorInfo);
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#000000',
          color: '#ffffff',
          padding: '40px 20px',
          borderRadius: '8px',
          height: '100%',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 15px 0', fontWeight: 'bold', fontSize: '18px' }}>
            Error al cargar el video
          </p>
          <p style={{ margin: '0', fontSize: '16px', lineHeight: '1.5', maxWidth: '400px' }}>
            El video no se puede reproducir en este momento.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default VimeoErrorBoundary;
